import { useContext, useEffect, useState } from 'react';
import { ApplicantContext } from './Applicants';
import css3 from '../Approvals/css/approval-table.module.css';
//../css/approval-table.module.css
import {FiMoreHorizontal as MoreIcon} from 'react-icons/fi';
import {MdOutlineArrowBackIosNew as LBtn,MdOutlineArrowForwardIos as RBtn} from 'react-icons/md';
import css4 from '../Approvals/css/approval-table.module.css';
import ViewApplicantDetails from './Modal/viewApplicant';


interface ApplicantDetails {
    ApplicantId: string;
    FirstName: string;
    MiddleName: string;
    LastName: string;
    Email: string;
    PhoneNumber: string;
    ContactAddress: string;
    Gender: string;
    Disablity?: any;
    IsSubmitted: boolean;
    RouteId: number;
    Title: string;
    BirthDate: string;
    WhatsAppNumber?: any;
    PhotoUrl: string;
    RouteName: string;
}

export const DATA_PER_PAGE = 10;

const ApplicantTable = (props:any) =>{
    const [activeData,setActiveData] = useState<any>([]);
    const [pageData,setPageData] = useState<any>([]);
    const [currentPage,setCurrentPage] = useState<number>(0);
    const [pageArr,setPageArr] = useState<any>([]);
    const [showMore,setShowMore] = useState<boolean>(false);
    const [showIndex,setShowIndex] = useState<any>(null);
    const data:any = props.data;
    const showNYSC = props.nysc;

    const {setShowModal,setModalView,setModalData} = useContext(ApplicantContext)
   

    const handlePrevous = () =>{
        if(currentPage === 0){
            if(pageArr.length > 1){
                setCurrentPage(pageArr.at(-1))
                return false;
            }
            setCurrentPage(0);
            return false;
 
        }
        setCurrentPage(currentPage-1);
    }

    const handleNext = ()=>{
        if(pageArr.length > 1){
            if(currentPage === pageArr.at(-1)){
                setCurrentPage(0);
                return false;
            }
            setCurrentPage(currentPage+1);
            return false;
        }
        setCurrentPage(0);
    }

    useEffect(()=>{
        if(data && data.length > 0){
            setActiveData(data);
            let lastPage = Math.ceil(data.length/10);
            let i = 0;
            let arr = [];
            for(i = 0;i<lastPage;i++){
                arr.push(i);
            }
            setPageArr(arr);
            setPageData(data.slice(0,DATA_PER_PAGE))
        }
    },[data])

    useEffect(()=>{
        if(activeData && activeData.length > 0){    
                let start = currentPage*DATA_PER_PAGE;
                let stop = start+DATA_PER_PAGE;
                setPageData(data.slice(start,stop));  
        }
    },[currentPage])

    // const handleViewApplicantDetails = (details:ApplicantDetails ) => {
    //     setModalData(details);
    //     setShowModal(true); 
    // }

    // const handleMore = (index:number) =>{
    //     if(index == showIndex){
    //         setShowIndex(null);
    //         setShowMore(false);
    //         return
    //     }
    //     setShowIndex(index);
    //     setShowMore(true);
    // }


    return ( 
            <>
                <div className={css4.container}>   
                    <div style={{gridTemplateColumns: `0.8fr 0.8fr 0.8fr 1.3fr 0.9fr 1fr`}}>
                        {/* <div>Tittle</div> */}
                        <div>First Name</div>
                        <div>Middle Name</div>
                        <div>LastName</div>
                        <div>Email</div>
                        <div>Phone Number</div>
                        {showNYSC? <div>NYSC</div>:<></>}
                        {/* <div>Academics</div> */}

                    </div>
                    <div>
                        {pageData && pageData.length > 0 && pageData.map((eData:any,index:number):any =>
                            <div key={index} style={{gridTemplateColumns:`0.8fr 0.8fr 0.8fr 1.3fr 0.9fr 1fr`}}>
                                    {/* <div>{eData.Title||'N/A'}</div> */}
                                    <div>{eData.FirstName}</div>
                                    <div>{eData.MiddleName}</div>
                                    <div>{eData.LastName}</div>
                                    <div>{eData.Email}</div>
                                    <div>{eData.PhoneNumber}</div>
                                    {showNYSC?<div>{eData.NYSCUploadDocumentUrl?'Yes':"No"}</div>:<></>}
                                    {/* <div>{eData.Academic}</div> */}

                                    <div>
                                        {/* {eData.Status?'Completed':'Incomplete'} */}
                                        {/* <span className={css4.moreSpan}><MoreIcon />
                                        </span> */} 
                                        <span  > 
                                           <div>
                                                {/* <div onClick={() => handleViewApplicantDetails(eData)} >View Details</div> */}
                                                {/* <div onClick={()=>handleApproveOrDecline(eData)}>Decline | Approve</div> */}
                                            </div>
                                        </span>
                                    </div>
                            </div>
                        )}
                    </div>
                    <div className={css3.pagination}>
                        <div>
                            <button className={`${css3.lBtn} ${css3.btn}`} onClick={handlePrevous}><LBtn/></button>
                            {pageArr && pageArr.length > 0 && pageArr.map((ePage: number, index: number) => {

                                if(index <= 2 && currentPage <= 2) return (<span
                                    style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                                    key={ePage} 
                                    onClick={() => setCurrentPage(ePage)}
                                >
                                    {ePage + 1}
                                </span>)  

                                if(index == currentPage ) return (<span
                                    style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                                    key={ePage} 
                                    onClick={() => setCurrentPage(ePage)}
                                >
                                    {ePage + 1}
                                </span>)  

                                if(index >= pageArr.length - 3 && currentPage >= pageArr.length -3) return (<span
                                    style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                                    key={ePage} 
                                    onClick={() => setCurrentPage(ePage)}
                                >
                                    {ePage + 1}
                                </span>)  

                                if(index == pageArr.length-1) return (
                                <>
                                    <>...</>
                                    <span 
                                    style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                                    key={ePage} 
                                    onClick={() => setCurrentPage(ePage)}
                                    >
                                        {ePage + 1}
                                    </span>
                                </>
                                )  

                                if(index == 0 ) return (
                                <>
                                    <span 
                                    style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                                    key={ePage} 
                                    onClick={() => setCurrentPage(ePage)}
                                    >
                                        {ePage + 1}
                                    </span>
                                    <>...</>
                                </>)  

                                })} 
                            <button className={`${css3.rBtn} ${css3.btn}`} onClick={handleNext}><RBtn/></button>
                        </div>
                    </div>
                </div>
               
            </>
    )
}


export default ApplicantTable;


// import { useContext, useEffect, useState } from 'react';
// import { ApplicantContext } from './Applicants';
// import css3 from '../Approvals/css/approval-table.module.css';
// //../css/approval-table.module.css
// import {FiMoreHorizontal as MoreIcon} from 'react-icons/fi';
// import {MdOutlineArrowBackIosNew as LBtn,MdOutlineArrowForwardIos as RBtn} from 'react-icons/md';
// import css4 from '../Approvals/css/approval-table.module.css';
// import ViewApplicantDetails from './Modal/viewApplicant';


// interface ApplicantDetails {
//     ApplicantId: string;
//     FirstName: string;
//     MiddleName: string;
//     LastName: string;
//     Email: string;
//     PhoneNumber: string;
//     ContactAddress: string;
//     Gender: string;
//     Disablity?: any;
//     IsSubmitted: boolean;
//     RouteId: number;
//     Title: string;
//     BirthDate: string;
//     WhatsAppNumber?: any;
//     PhotoUrl: string;
//     RouteName: string;
// }

// export const DATA_PER_PAGE = 10;

// const ApplicantTable = (props:any) =>{
//     const [activeData,setActiveData] = useState<any>([]);
//     const [pageData,setPageData] = useState<any>([]);
//     const [currentPage,setCurrentPage] = useState<number>(0);
//     const [pageArr,setPageArr] = useState<any>([]);
//     const [showMore,setShowMore] = useState<boolean>(false);
//     const [showIndex,setShowIndex] = useState<any>(null);
//     const data:any = props.data;
//     const showNYSC = props.nysc;

//     const {setShowModal,setModalView,setModalData} = useContext(ApplicantContext)
   

//     const handlePrevous = () =>{
//         if(currentPage === 0){
//             if(pageArr.length > 1){
//                 setCurrentPage(pageArr.at(-1))
//                 return false;
//             }
//             setCurrentPage(0);
//             return false;
 
//         }
//         setCurrentPage(currentPage-1);
//     }

//     const handleNext = ()=>{
//         if(pageArr.length > 1){
//             if(currentPage === pageArr.at(-1)){
//                 setCurrentPage(0);
//                 return false;
//             }
//             setCurrentPage(currentPage+1);
//             return false;
//         }
//         setCurrentPage(0);
//     }

//     useEffect(()=>{
//         if(data && data.length > 0){
//             setActiveData(data);
//             let lastPage = Math.ceil(data.length/10);
//             let i = 0;
//             let arr = [];
//             for(i = 0;i<lastPage;i++){
//                 arr.push(i);
//             }
//             setPageArr(arr);
//             setPageData(data.slice(0,DATA_PER_PAGE))
//         }
//     },[data])

//     useEffect(()=>{
//         if(activeData && activeData.length > 0){    
//                 let start = currentPage*DATA_PER_PAGE;
//                 let stop = start+DATA_PER_PAGE;
//                 setPageData(data.slice(start,stop));  
//         }
//     },[currentPage])

//     const handleViewApplicantDetails = (details:ApplicantDetails ) => {
//         setModalData(details);
//         setShowModal(true); 
//     }

//     const handleMore = (index:number) =>{
//         if(index == showIndex){
//             setShowIndex(null);
//             setShowMore(false);
//             return
//         }
//         setShowIndex(index);
//         setShowMore(true);
//     }


//     return ( 
//             <>
//                 <div className={css4.container}>   
//                     <div style={{gridTemplateColumns:`0.8fr 0.8fr 0.8fr 1.3fr 0.9fr 1fr`}}>
//                         <div>Tittle</div>
//                         <div>First Name</div>
//                         <div>Middle Name</div>
//                         <div>LastName</div>
//                         <div>Email</div>
//                         <div>Phone Number</div>
//                         {showNYSC? <div>NYSC</div>:<></>}
//                         {/* <div>
//                             BirthDat
//                         </div> */}
//                     </div>
//                     <div>
//                         {pageData && pageData.length > 0 && pageData.map((eData:any,index:number):any =>
//                             <div key={index} style={{gridTemplateColumns:`0.8fr 0.8fr 0.8fr 0.8fr 0.9fr 1fr`}}>
//                                     <div>{eData.Title||'N/A'}</div>
//                                     <div>{eData.FirstName}</div>
//                                     <div>{eData.MiddleName}</div>
//                                     <div>{eData.LastName}</div>
//                                     <div>{eData.Email}</div>
//                                     <div>{eData.PhoneNumber}</div>
//                                     {showNYSC?<div>{eData.NYSCUploadDocumentUrl?'Yes':"No"}</div>:<></>}
//                                     <div>
//                                         {/* {eData.Status?'Completed':'Incomplete'} */}
//                                         <span className={css4.moreSpan}><MoreIcon />
//                                         </span>
//                                         <span  className={`${css4.moreSpan} ${index == showIndex?`${css4.activeMore}`:''} `} onClick={()=>handleMore(index)}><MoreIcon />
//                                             {index == showIndex && showMore ?<div>
//                                                 <div onClick={() => handleViewApplicantDetails(eData)} >View Details</div>
//                                                 {/* <div onClick={()=>handleApproveOrDecline(eData)}>Decline | Approve</div> */}
//                                             </div>:''}
//                                         </span>
//                                     </div>
//                             </div>
//                         )}
//                     </div>
//                     <div className={css3.pagination}>
//                         <div>
//                             <button className={`${css3.lBtn} ${css3.btn}`} onClick={handlePrevous}><LBtn/></button>
//                             {pageArr && pageArr.length > 0 && pageArr.map((ePage: number, index: number) => {

//                                 if(index <= 2 && currentPage <= 2) return (<span
//                                     style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
//                                     key={ePage} 
//                                     onClick={() => setCurrentPage(ePage)}
//                                 >
//                                     {ePage + 1}
//                                 </span>)  

//                                 if(index == currentPage ) return (<span
//                                     style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
//                                     key={ePage} 
//                                     onClick={() => setCurrentPage(ePage)}
//                                 >
//                                     {ePage + 1}
//                                 </span>)  

//                                 if(index >= pageArr.length - 3 && currentPage >= pageArr.length -3) return (<span
//                                     style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
//                                     key={ePage} 
//                                     onClick={() => setCurrentPage(ePage)}
//                                 >
//                                     {ePage + 1}
//                                 </span>)  

//                                 if(index == pageArr.length-1) return (
//                                 <>
//                                     <>...</>
//                                     <span 
//                                     style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
//                                     key={ePage} 
//                                     onClick={() => setCurrentPage(ePage)}
//                                     >
//                                         {ePage + 1}
//                                     </span>
//                                 </>
//                                 )  

//                                 if(index == 0 ) return (
//                                 <>
//                                     <span 
//                                     style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
//                                     key={ePage} 
//                                     onClick={() => setCurrentPage(ePage)}
//                                     >
//                                         {ePage + 1}
//                                     </span>
//                                     <>...</>
//                                 </>)  

//                                 })} 
//                             <button className={`${css3.rBtn} ${css3.btn}`} onClick={handleNext}><RBtn/></button>
//                         </div>
//                     </div>
//                 </div>
               
//             </>
//     )
// }


// export default ApplicantTable;

